import { jsx } from "react/jsx-runtime";
import { RouterProvider } from "@tanstack/react-router";
import { hydrate } from "./ssr-client.js";
function StartClient(props) {
  if (!props.router.state.matches.length) {
    hydrate(props.router);
  }
  return /* @__PURE__ */ jsx(RouterProvider, { router: props.router });
}
export {
  StartClient
};
//# sourceMappingURL=StartClient.js.map
